const MODULE_LABELS = {
  fancam: 'FanCam',
  tiri: 'TIRI',
  tagit: 'TIRI – Tag It',
  rateit: 'TIRI – Rate It',
  fanwave: 'FanWave',
  goalrush: 'GoalRush',
  replay: 'P4P Replay',
  rewards: 'Rewards',
  predictions: 'Predictions',
  quizzes: 'Quizzes',
  polls: 'Polls',
  ptw: 'GloryBoard',
  fanchat: 'FanChat',
  playerStats: 'Game Stat'
};

const fmtNumber = (n) => (n || 0).toLocaleString();

/**
 * Ranked bar-list, not a bordered table — same pattern as Stripe's "Top destinations" and
 * Vercel Analytics' "Top pages" panels: a label, a proportional bar against the leading row,
 * and the number. Reads as a ranking at a glance instead of a grid of cells to scan.
 */
const ModuleBreakdownTable = ({ rows, loading, onModuleClick, selectedModule, compact }) => {
  const maxTotal = Math.max(1, ...(rows || []).map((r) => r.total || 0));

  if (loading) {
    return (
      <div className="bg-white rounded-xl border border-[#E2E8F0] p-5 space-y-3 animate-pulse">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="h-8 w-full bg-[#F1F5F9] rounded" />
        ))}
      </div>
    );
  }

  if (!rows?.length) {
    return (
      <div className="bg-white rounded-xl border border-[#E2E8F0] p-8 text-center">
        <p className="text-[13px] font-medium text-[#334155]">No activity yet</p>
        <p className="text-[12px] text-[#94A3B8] mt-1">
          Nothing logged for this filter across any module.
        </p>
      </div>
    );
  }

  const sorted = [...rows].sort((a, b) => b.total - a.total);

  return (
    <div className="bg-white rounded-xl border border-[#E2E8F0] overflow-hidden">
      {!compact && (
        <div className="px-5 py-3.5 border-b border-[#E2E8F0] bg-[#F8FAFC]">
          <p className="text-[13px] font-semibold text-[#0F172A]">Modules</p>
          <p className="text-[11px] text-[#94A3B8]">Click one to see individual items</p>
        </div>
      )}

      <div className={compact ? 'py-1' : 'py-2'}>
        {sorted.map((row) => {
          const isSelected = selectedModule === row.module;
          const barWidth = `${Math.max(4, (row.total / maxTotal) * 100)}%`;

          return (
            <button
              key={row.module}
              onClick={() => onModuleClick?.(row.module)}
              className={`w-full text-left flex items-center gap-3 px-5 transition-colors ${
                compact ? 'py-2.5' : 'py-2.5'
              } ${isSelected ? 'bg-[#EEF2FF]' : 'hover:bg-[#F8FAFC]'}`}
            >
              <span
                className={`shrink-0 rounded-full ${isSelected ? 'bg-[#3B5BDB]' : 'bg-[#CBD5E1]'}`}
                style={{ width: 6, height: 6 }}
              />
              <span
                className={`shrink-0 text-[13px] ${
                  isSelected ? 'font-semibold text-[#3B5BDB]' : 'font-medium text-[#334155]'
                } ${compact ? 'w-[92px]' : 'w-[130px]'} truncate`}
              >
                {MODULE_LABELS[row.module] || row.module}
              </span>

              <span className="flex-1 h-1.5 rounded-full bg-[#F1F5F9] overflow-hidden">
                <span
                  className={`block h-full rounded-full ${isSelected ? 'bg-[#3B5BDB]' : 'bg-[#94A3B8]'}`}
                  style={{ width: barWidth }}
                />
              </span>

              <span className="shrink-0 text-[13px] font-semibold text-[#0F172A] tabular-nums w-12 text-right">
                {fmtNumber(row.total)}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ModuleBreakdownTable;
